import {useTranslation} from "react-i18next";

const NoAttachmentWarning = () => {
    const {t, i18n} = useTranslation()

    return (
        <div className="mt-3 p-3 border border-warning rounded bg-light">
            <p className="mb-2 text-warning fw-bold">
                {t("emission.form.attachment.info.title")}
            </p>
            <p className="mb-0 text-muted">
                {t("emission.form.attachment.info.subtitle1")}
            </p>
            <p className="mt-2 mb-0 text-muted">
                {t("emission.form.attachment.info.subtitle2")}
            </p>
        </div>
    )
}

export default NoAttachmentWarning
